import React, { useState } from "react";
import { Badge, Popover, Button, Drawer, Tabs } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import { setUser } from "../redux/userSlice";
import axios from "axios";
import { toast } from "react-hot-toast";
import moment from "moment";

const NotificationBell = () => {
  const { user } = useSelector((s) => s.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [popoverOpen, setPopoverOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const markAllSeen = async () => {
    try {
      dispatch(showLoading());
      const { data } = await axios.post(
        "/api/user/mark-all-notifications-seen",
        { userId: user._id },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      dispatch(hideLoading());
      if (data.success) {
        toast.success(data.message);
        dispatch(setUser(data.data));
      } else toast.error(data.message);
    } catch (_) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  const deleteAll = async () => {
    try {
      dispatch(showLoading());
      const { data } = await axios.post(
        "/api/user/delete-all-notifications",
        { userId: user._id },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      dispatch(hideLoading());
      if (data.success) {
        toast.success(data.message);
        dispatch(setUser(data.data));
      } else toast.error(data.message);
    } catch (_) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  const quick = (user?.unseenNotifications || []).slice(0, 3);

  const handleNotificationClick = (notif) => {
    setPopoverOpen(false);
    setDrawerOpen(false);
    if (notif?.onClickPath) {
      navigate(notif.onClickPath);
    } else {
      if (user?.isAdmin) navigate("/admin/doctorslist");
      else if (user?.isDoctor) navigate("/doctor/reviews");
    }
  };

  const popoverContent = (
    <div style={{ maxWidth: 300 }}>
      {quick.map((n, i) => (
        <div
          key={n._id || i}
          className="p-2 border-bottom"
          style={{ cursor: "pointer" }}
          onClick={() => handleNotificationClick(n)}
        >
          <div>{n.message}</div>
          <small className="text-muted">{moment(n.createdAt).fromNow()}</small>
        </div>
      ))}

      {user?.unseenNotifications.length >= 1 && (
        <Button
          block
          type="link"
          onClick={() => {
            setDrawerOpen(true);
            setPopoverOpen(false);
          }}
        >
          Show All
        </Button>
      )}

      {user?.unseenNotifications.length === 0 && (
        <p style={{ margin: 0 }}>No new notifications.</p>
      )}
    </div>
  );

  return (
    <>
      <Popover
        content={popoverContent}
        trigger="click"
        placement="bottomRight"
        open={popoverOpen}
        onOpenChange={setPopoverOpen}
      >
        <Badge
          count={user?.unseenNotifications.length}
          className={user?.unseenNotifications.length ? "shake" : ""}
          onClick={() => {
            if ((user?.unseenNotifications || []).length === 0) {
              setDrawerOpen(true);
            }
          }}
        >
          <i
            className="ri-notification-4-line close-icon mr-4"
            style={{ cursor: "pointer" }}
          />
        </Badge>
      </Popover>

      <Drawer
        title="🔔 Notifications"
        width={420}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Tabs
          defaultActiveKey="0"
          items={[
            {
              key: "0",
              label: "Unseen",
              children: (
                <>
                  <div className="d-flex justify-content-end mb-2">
                    <Button type="link" onClick={markAllSeen}>
                      Mark all seen
                    </Button>
                  </div>
                  {user?.unseenNotifications.length === 0 && <p>No new notifications.</p>}
                  {user?.unseenNotifications.map((n, i) => (
                    <div
                      key={n._id || i}
                      className="card p-2 mt-2"
                      onClick={() => handleNotificationClick(n)}
                    >
                      <div>{n.message}</div>
                      <small className="text-muted">{moment(n.createdAt).fromNow()}</small>
                    </div>
                  ))}
                </>
              ),
            },
            {
              key: "1",
              label: "Seen",
              children: (
                <>
                  <div className="d-flex justify-content-end mb-2">
                    <Button type="link" onClick={deleteAll}>
                      Delete all
                    </Button>
                  </div>
                  {user?.seenNotifications.length === 0 && <p>No seen notifications.</p>}
                  {user?.seenNotifications.map((n, i) => (
                    <div
                      key={n._id || i}
                      className="card p-2 mt-2"
                      onClick={() => handleNotificationClick(n)}
                    >
                      <div>{n.message}</div>
                      <small className="text-muted">{moment(n.createdAt).fromNow()}</small>
                    </div>
                  ))}
                </>
              ),
            },
          ]}
        />
      </Drawer>
    </>
  );
};

export default NotificationBell;
